import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { AuthMapService } from '../../services/auth-map.service';
import { GoogleMapService } from '../../services/google-map.service';
import { OpenlayerMapService } from '../../services/openlayer-map.service';
import { CommonService } from '../../services/common.service';
import { AjaxService } from '../../services/ajax.service';
import { app, serverUrl, storageVariable, languageInitializer } from '../../../environments/environment';
import { WebsocketService } from '../../services/websocket.service';
import { websocket } from '../../interfaces/webSocket';
import { DatePipe } from '@angular/common'
import { ActivatedRoute, Route, Router } from '@angular/router';
import {
  trigger,
  style,
  state,
  animate,
  transition
} from '@angular/animations';
import { MenuController, Platform } from '@ionic/angular';
interface coordinates {
  lat: number;
  lng: number;
}

@Component({
  selector: 'app-vtslivetrack',
  templateUrl: './vtslivetrack.component.html',
  styleUrls: ['./vtslivetrack.component.scss'],
  providers: [DatePipe],
  animations: [
    trigger(
      'slide',
      [
        transition(':enter', [
          style({ transform: 'translateY(100%)' }),
          animate('0.3s ease-in')
        ]),
        transition(':leave', [
          animate('0.3s ease-out')
        ])
      ]
    )
  ]
})
export class VtslivetrackComponent implements OnInit, websocket {
  @Input() cardView;
  @Input('multiTrackObj') multiTrackObj = {}
  @Input('fromMultiTrack') fromMultiTrack = false
  map;
  map2;
  paramVin;
  ioData;
  appName;
  dashboardData;
  odometerReading;
  UpdatedTime;
  layerModal = false;
  traveVinData;
  transitionCount = 0;
  liveTrackPhoneNo = localStorage.getItem('PhoneNumber');
  liveTrackStatus;
  liveTrackSpeed;
  liveTrackTimeStamp;
  locationTimeStamp;
  liveTrackPlateNo;
  livetrackingAddress;
  liveTrackModel;
  position: coordinates = { "lat": 0, "lng": 0 };
  deltaLat;
  deltaLng;
  numDeltas = 700;
  hitPermission;
  displayText = 'Click here to locate Address';
  liveTrackOdometer;
  liveTrackCummulativeOdometer;
  liveTrackEngineValue;
  liveTrackFinalvalue;
  vin;
  gps;
  gsm;
  battery;
  powerSupplyVoltage;
  engine;
  ac;
  door;
  seatBelt;
  fabButton = true;
  icon = "assets/vtstrackhisIcon/";
  @Output() gridView = new EventEmitter();
  @Input() gridLiveChange;
  model;
  appSettings;
  showSwipeModal: boolean = true;
  toggleShow: boolean = false;
  // restrictedCommandImei = ["357544376950214", "864431049839964"];
  trackHistoryJson;
  currentState: string = "history";
  @ViewChild('mapElement', { static: false }) mapElement;
  @ViewChild('modal', { static: false }) modal;
  @Input() liveTrackChanging = undefined;
  locationIQ: any = [];
  count = 0;
  directory: string = languageInitializer.directory;
  pageSelector: any;
  constructor(
    public mapService: AuthMapService,
    public gMapService: GoogleMapService,
    public olMapService: OpenlayerMapService,
    public activatedRoute: ActivatedRoute,
    public commonService: CommonService,
    public router: Router,
    public ajaxService: AjaxService,
    public websocketService: WebsocketService,
    public menuController: MenuController,
    public datePipe: DatePipe,
    // public platform: Platform

  ) {
    if (localStorage.map == "GoogleMap") {
      this.mapService = new GoogleMapService();
      this.fabButton = false;
    }
    else {
      this.mapService = new OpenlayerMapService();
    }
  }

  wsResponse(res) {
    // console.log("res vts-live",res);
    console.log(res, res.alerts, "vtslivetrack");
    if (Array.isArray(res.alerts) && res.alerts.length !== 0 && app.entryPoint == "ATM") {
      if (res.alerts[0].vid.alerttype == "POWERCUT" || res.alerts[0].vid.alerttype == "MOVEMENT") {
        this.commonService.playAudio();
      }
    } else {
      if (Array.isArray(res.alerts) && res.alerts.length !== 0)
        if (res.alerts[0].vid.alerttype == "SOS") {
          this.commonService.playAudio();
        }
    }

    var data = res.liveDatas
    if (data) {
      if (data[this.vin] != undefined) {
        this.liveTrackModel = this.getLiveTrackIcon(this.commonService.color[res["liveDatas"][this.vin].status], this.commonService.vehicleModelmap[res["liveDatas"][this.vin].icon]);
        this.currentState = "live";
        res["liveDatas"][this.vin]["odometer"] = parseInt(res["liveDatas"][this.vin]["odometer"]) / 1000;
        this.traveVinData = res["liveDatas"][this.vin];
        var constData = res;
        this.successLiveVariableData(constData);
        // this.updateCellData();
      }
    }
  }
  wsOnError() {
  }



  createMap() {
    setTimeout(() => {
      const myLatlng = {
        lat: this.traveVinData.latitude,
        lng: this.traveVinData.longitude
      };
      if (this.gridLiveChange == undefined || !this.map) {

        this.map = this.mapService.loadMap(this.mapElement.nativeElement, { lat: this.traveVinData.latitude, lng: this.traveVinData.longitude }, false, false);
      }
      this.mapService.setCenter(this.map, { lat: 17.786351, lng: 78.090820 });
      this.mapService.clearLayers(this.map, [1, 2])
      this.vin = this.traveVinData.vin;
      this.locationIQ = [];//unused 
      this.count = 0
      this.liveTrackPlateNo = this.traveVinData.plateNo;
      this.liveTrackModel = this.getLiveTrackIcon(this.commonService.color[this.traveVinData.status], this.commonService.vehicleModelmap[this.traveVinData.icon]);
      this.updateCellData();
      this.mapService.addMarker(this.map, myLatlng, 'livetrack', this.liveTrackModel);
      this.mapService.setCenter(this.map, myLatlng);

      if (localStorage.map != "GoogleMap") {
        setTimeout(() => {
          this.mapService.fitBounds(this.map, 1);
        }, 500);
      }
      this.getLiveVariableData();
    }, 500);

  }

  switchMap() {
    this.layerModal = !this.layerModal
    this.map.getLayers().item(3).setVisible(this.layerModal);
    this.map.getLayers().item(0).setVisible(!this.layerModal);
  }
  updateCellData() { // dont delete unused function
    this.liveTrackSpeed = this.traveVinData.speed;
    this.liveTrackStatus = this.traveVinData.status;
    this.liveTrackTimeStamp = this.traveVinData.timeStamp;
    this.getAddress(this.traveVinData.latitude, this.traveVinData.longitude);
    this.liveTrackOdometer = (this.traveVinData.odometer / 1000).toFixed(3);
    this.liveTrackCummulativeOdometer = this.traveVinData.finalOdometer;
    this.liveTrackEngineValue = this.traveVinData.engineHours;
    this.liveTrackFinalvalue = this.traveVinData.finalEngineValue;
    this.gps = this.getIconColor('gps', this.traveVinData.gps);
    this.gsm = this.getIconColor('gsm', this.traveVinData.gsmSignalStrength);
    this.battery = this.getIconColor('battery', this.traveVinData.batteryvoltage);
    this.powerSupplyVoltage = this.getIconColor('powerSupplyVoltage', this.traveVinData.powerSupplyVoltage);
    this.engine = this.getIconColor('ignition', this.traveVinData.engineId);
    this.ac = this.getIconColor('acSensor', this.getIoDigitalinput("AirConditioner"));
    this.door = this.getIconColor('seatBelt', this.getIoDigitalinput("Door Sensor"));
    this.seatBelt = this.getIconColor('doorSensor', this.getIoDigitalinput("Seat Belt"));
  }

  getLiveVariableData() {
    const duration = this.appSettings.liveTrackingDelay;

    const credentials = {
      dashboardVin: this.vin,
      defaultInterval: duration,
      make: this.traveVinData.make,
      model: this.traveVinData.model,
      delay: duration,
      ImeiNo: this.traveVinData.imeiNo,
      entryPoint: app.entryPoint,
      Check: false,
      emailId: localStorage.userName,
      branchID: localStorage.corpId,
      companyID: localStorage.corpId,
      mode: 'liveTrackConnect'
    };
    // if (!this.restrictedCommandImei.includes(this.traveVinData.imeiNo))
    this.websocketService.reSendRequest(credentials);


  }
  check() { // unused function dont delete
    this.websocketService.isAlive('livetrack');
  }

  showTrackingPopup(myLatlng, liveVarData) { // unused function dont delete
    this.liveTrackStatus = this.commonService
      .liveTrackingStatus(liveVarData.model, liveVarData.status);
    this.liveTrackSpeed = liveVarData.speed + ' km/hr';
    this.liveTrackTimeStamp = liveVarData.timeStamp;
    this.locationTimeStamp = liveVarData.locationTimeStamp;
    this.liveTrackPlateNo = liveVarData.plateNo;
  }

  setLiveMarker(liveData, liveTatLng, check, check1, lineArray) {
    if (check) {
      if (check1) {
        this.mapService.moveMarker(this.map, 'livetrack', liveTatLng.lng, liveTatLng.lat, this.liveTrackModel, '', lineArray);
      } else {
        this.mapService.moveMarker(this.map, 'livetrack', liveTatLng.lng, liveTatLng.lat, this.liveTrackModel, '', lineArray);

      }
    } else {
      this.mapService.moveMarker(this.map, 'livetrack', liveTatLng.lng, liveTatLng.lat, this.liveTrackModel, '', lineArray);
      if (this.transitionCount === 100 || liveData.status === 'Running' || liveData.status === 'OverSpeed') {
      } else if (liveData.status === 'Stop' || liveData.status === 'Idle') {

      }
    }
  }

  // successLiveVariableData(data) {
  //   // this.count = 0;
  //   // this.locationIQ = []
  //   let currLatLng = {
  //     lat: data["liveDatas"][this.vin].latitude,
  //     lng: data["liveDatas"][this.vin].longitude
  //   };
  //   if (this.position.lat == 0 || this.position.lng == 0 || this.position.lat.toString() == "NaN" || this.position.lng.toString() == "NaN") {
  //     this.position.lat = currLatLng.lat;
  //     this.position.lng = currLatLng.lng;
  //   }

  //     var url = 'https://us1.locationiq.com/v1/matching/driving/' + this.position.lng + ',' + this.position.lat + ';' + this.traveVinData.longitude + ',' + this.traveVinData.latitude + '?key=c9cc1b3d7159e1&steps=false&geometries=geojson&radiuses=25;25&overview=full';
  //   this.ajaxService.ajaxGet(url).subscribe(async res => {
  //     if (res) {
  //       let newLength = res.matchings[0]["geometry"]["coordinates"]
  //       for (let i = 0; i < newLength.length; i++) {
  //         this.locationIQ.push(newLength[i])
  //       }

  //       for (this.count; this.count < this.locationIQ.length; this.count++) {
  //         let currLatLng = {
  //           lat: this.locationIQ[this.count][1],
  //           lng: this.locationIQ[this.count][0]
  //         };
  //         if (this.count != 0) {
  //           this.position.lng = this.locationIQ[this.count - 1][0];
  //           this.position.lat = this.locationIQ[this.count - 1][1];
  //           let currLatLng = {
  //             lat: this.locationIQ[this.count-1][1],
  //             lng: this.locationIQ[this.count-1][0]
  //           };
  //         }
  //         this.traveVinData.latitude = this.locationIQ[this.count][1];
  //         this.traveVinData.longitude = this.locationIQ[this.count][0];
  //         this.setLiveMarker(this.traveVinData, currLatLng, true, false, []);
  //         this.plotMarkerinMap(currLatLng);
  //       }
  //     }
  //   })
  // }

  toggleViews() {
    this.toggleShow = !this.toggleShow;

  }

  successLiveVariableData(data) {
    let currLatLng
    if (this.fromMultiTrack) {
      currLatLng = {
        lat: data.latitude,
        lng: data.longitude
      };
    } else {
      currLatLng = {
        lat: data["liveDatas"][this.vin].latitude,
        lng: data["liveDatas"][this.vin].longitude
      };
    }

    this.setLiveMarker(this.traveVinData, currLatLng, true, false, []);

    this.plotMarkerinMap(currLatLng);
  }

  plotMarkerinMap(currLatLng) {

    if (this.position.lat == 0 || this.position.lng == 0) {
      this.position.lat = currLatLng.lat;
      this.position.lng = currLatLng.lng;
    }
    const result = {
      lat: this.traveVinData.latitude,
      lng: this.traveVinData.longitude
    };
    if (this.position.lat !== result.lat && this.position.lng !== result.lng) {
      this.transition(result);

    } else {
      this.setLiveMarker(this.traveVinData, result, true, true, []);
      // this.transition(result);
    }
  }

  transition(result) {
    this.transitionCount = 0;
    this.deltaLat = (result.lat - this.position.lat)
      / this.numDeltas;
    this.deltaLng = (result.lng - this.position.lng)
      / this.numDeltas;
    this.moveMarker();
  }

  async moveMarker() {
    let lineArray;
    let prevLatLng = {
      "lat": this.position.lat,
      "lng": this.position.lng
    }
    this.position.lat += this.deltaLat;
    this.position.lng += this.deltaLng;
    const latlng = {
      lat: this.position.lat,
      lng: this.position.lng
    };
    let latLng = {
      "lat": this.position.lat,
      "lng": this.position.lng
    };
    lineArray = [prevLatLng, latLng];
    this.setLiveMarker(this.traveVinData, latlng, false, false, lineArray);
    if (this.transitionCount <= this.numDeltas) {
      this.transitionCount++;
      await this.delay(10);
      this.moveMarker();
    }
  }

  getAddress(lat, lng) {
    const url = serverUrl.web + "/login/company/latlngtoaddress/" + this.traveVinData.latitude + "/" + this.traveVinData.longitude + "/" + localStorage.corpId + "/" + localStorage.lang;
    this.ajaxService.ajaxGetObject(url)
      .subscribe(res => {
        this.livetrackingAddress = res;
      });
  }

  toggleView() {
    this.showSwipeModal = !this.showSwipeModal;
  }
  getIoDigitalinput(type) {
    if (this.ioData)
      for (let x in this.ioData[this.paramVin]) {
        if (type == this.ioData[this.paramVin][x]["ioname"]) {
          let value: string;
          switch (this.ioData[this.paramVin][x]["IO"]) {
            case 1:
              value = this.traveVinData.digitalInput1;
              break;
            case 2:
              value = this.traveVinData.digitalInput2;
              break;
            case 3:
              value = this.traveVinData.digitalInput3;
              break;
            case 4:
              value = this.traveVinData.digitalInput4;
              break;
            default:
              value = null;
              break;
          }

        }
      }
    return null;
  }
  getIconColor(icon, value) {
    let path;
    switch (value) {
      case 'ON':
        path = this.icon + icon + "On.svg";
        break;
      case 'OFF':
        path = this.icon + icon + "Off.svg";
        break;
      case true:
        path = this.icon + icon + "On.svg";
        break;
      case false:
        path = this.icon + icon + "Off.svg";
        break;
      case "true":
        path = this.icon + icon + "On.svg";
        break;
      case "false":
        path = this.icon + icon + "Off.svg";
        break;
      case '1':
        path = this.icon + icon + "Off.svg";
        break;
      case null:
        path = this.icon + icon + ".svg";
        break;
      default:
        path = this.icon + icon + "On.svg";
    }
    return path;
  }
  async delay(milliseconds: number) {
    return new Promise<void>(resolve => {
      setTimeout(resolve, milliseconds);
    });
  }

  ngOnDestroy() {
    if (this.websocketService.isAlive('livetrack')) {
      const duration = this.appSettings.liveTrackingDisconnect ? this.appSettings.liveTrackingDisconnect : this.appSettings.liveTrackingDelay;
      // this.websocketService.disConnectSocket('livetrack');
      const credentials = {
        dashboardVin: this.vin,
        defaultInterval: duration,
        make: storageVariable.upDatedJsonData.liveDatas[this.vin].make,
        model: storageVariable.upDatedJsonData.liveDatas[this.vin].model,
        delay: duration,
        ImeiNo: storageVariable.upDatedJsonData.liveDatas[this.vin].imeiNo,
        entryPoint: app.entryPoint,
        Check: false,
        emailId: localStorage.userName,
        branchID: localStorage.corpId,
        companyID: localStorage.corpId,
        // mode: "mobile"
        mode: 'liveTrackDisConnect'
      };

      // this.websocketService.setProductService(this);
      // this.websocketService.connectSocket(credentials, 'livetrack');
      // if (!this.restrictedCommandImei.includes(this.traveVinData.imeiNo))
      this.websocketService.reSendRequest(credentials);
    }

    this.mapService.clearLayers(this.map, [1, 2])
  }

  ionViewWillEnter() {
    setTimeout(() => {
      this.map.setTarget(this.mapElement.nativeElement);
    }, 2000);
  }

  getLiveTrackIcon = (color, path) => {
    if (path == undefined || path == null) {
      path = this.commonService.vehicleModelmap["CAR"]
    }
    if (this.traveVinData.icon == "REFRIGERATOR" || this.traveVinData.icon == "STREET SWEEPER") {
      var viewbox = "-220 -1000 2471.4 2448.1";
    }
    else {
      var viewbox = "-950 -1600 2471.4 2448.1";
    }
    let svg = '<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="24.714mm" height="24.481mm" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"  ' +
      '   viewBox="'
      + viewbox +
      '"    xmlns:xlink="http://www.w3.org/1999/xlink"> <path class="fil0" d="'
      + path
      + '" fill="'
      + color
      + '"/> </svg>';

      if (app.entryPoint == "WFT")
      svg = `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="20mm" height="20mm" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"  viewBox="0 -700 600.4 1548.1"  xmlns:xlink="http://www.w3.org/1999/xlink">
      <path fill="${color}" d="M308.39 820.52c7.93,-5.39 22.74,-25.21 31.19,-34.54 4.5,-4.96 6.68,-7.44 10.81,-12.32 13.75,-16.21 26.97,-32.81 40.77,-49.55 27.52,-33.41 51.55,-66.36 78.26,-102.19 45.87,-61.48 105.82,-157.78 131.51,-228.19 19.86,-54.37 22.8,-94.92 9.4,-154.59 -28.91,-128.85 -148.82,-238.55 -301.79,-238.39 -57.68,0.07 -99.9,14.16 -143.75,35.48 -18.95,9.22 -40.4,24.78 -54.11,36.16 -47.86,39.76 -87.79,99.86 -103.04,166.42 -13.17,57.47 -10.42,101.62 9.13,154.27 33.45,90.11 110.12,204.33 169.31,279.35 6.69,8.48 13.02,16.66 19.69,25.42 31.33,41.1 68.67,83.6 102.62,122.67zm-91.96 -457.11l0 70.27 185.2 0 0 -70.27c0,-15.94 -6.44,-33.7 -14.55,-45.81l-8.8 -11.88c-21.18,-22.85 -23.92,-15.31 -39,-9.62 -3.69,1.39 -12.54,3.64 -17.03,3.64l0 65.32c0,20.67 -26.45,20.67 -26.45,0l0 -65.32c-4.4,0 -12.9,-2.15 -16.43,-3.42 -8.9,-3.18 -14.09,-8.4 -22.55,-4.98 -2.19,0.9 -3.94,2.56 -5.9,4.03 -6.3,4.7 -10.44,9.47 -15.22,15.37 -10.73,13.22 -19.27,34.8 -19.27,52.67zm171.97 -118.23l0 6.62c0,24.96 24.64,49.59 49.61,49.59l6.61 0c24.97,0 49.61,-24.63 49.61,-49.59l0 -6.62c0,-24.97 -24.64,-49.61 -49.61,-49.61l-6.61 0c-24.97,0 -49.61,24.64 -49.61,49.61zm-264.57 0l0 6.62c0,24.96 24.64,49.59 49.61,49.59l6.61 0c24.97,0 49.61,-24.63 49.61,-49.59l0 -6.62c0,-24.97 -24.64,-49.61 -49.61,-49.61l-6.61 0c-24.97,0 -49.61,24.64 -49.61,49.61zm-13.23 119.05l0 57.88c0,5.16 6.41,11.57 11.57,11.57l67.8 0c0,-26.79 -2.14,-72.3 4.13,-95.91 3.41,-12.82 10.28,-26.05 10.76,-28.11 -5.87,0 -8.35,1.66 -13.55,2.99 -31.15,8 -36.23,-10.65 -51.95,0.14 -15.05,10.32 -28.76,29.45 -28.76,51.44zm330.72 -49.61c-3.75,0 -11.13,-1.08 -14.57,-1.97 -5.2,-1.33 -7.68,-2.99 -13.55,-2.99 0.42,1.77 7.36,15.7 10.58,27.46 6.51,23.71 4.31,69.65 4.31,96.56l67.8 0c5.16,0 11.57,-6.41 11.57,-11.57l0 -57.88c0,-18.22 -10.28,-34.7 -19.62,-44.04 -20.65,-20.63 -23.06,-5.57 -46.52,-5.57zm-198.43 -109.13c0,21.76 5.65,36.66 19.21,50.24 25.88,25.87 68.24,25.63 93.86,0.01 25.62,-25.62 25.87,-67.99 -0.01,-93.86 -25.77,-25.78 -68.08,-25.78 -93.85,0 -9.14,9.14 -19.21,25.74 -19.21,43.61zm31.19 -146.63c-131.97,17.76 -244.14,138.21 -224,293.5 17.03,131.47 139.15,243.81 292.89,224.18 131.7,-16.82 245.65,-139.54 224.9,-293.98 -17.7,-131.69 -139.26,-244.5 -293.79,-223.7z"/>
      </svg>`;
    // svg = `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="24.714mm" height="15.481mm" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"  ' +
    // '   viewBox="0 0 2471.4 1548.1"  ' +
    // '    xmlns:xlink="http://www.w3.org/1999/xlink">
    //   <path `+ `fill="`
    //   + color
    //   + `" d="M185.45 141.92c1.88,-0.62 3.59,-0.87 4.42,1.01l0.12 -39.84c-9.89,-1.85 -20.2,7.31 -23.44,11.92 -6.64,9.41 -5.4,17.94 -5.4,30.53 0,24.09 0.02,48.19 0,72.28 0,5.04 -0.84,12.18 1.45,16.27 1.99,3.56 6.15,6.96 12.29,6.12 11.97,-1.65 10.02,-15.29 10,-26.37 -0.02,-11.15 -1.26,-65.87 0.56,-71.92zm56.48 282.37l-15.27 15.27 -15.27 -15.27c-40.35,-7.21 -70.98,-42.48 -70.98,-84.9 0,-2.33 0.09,-4.64 0.28,-6.93 3.53,44.39 40.76,81.52 86.06,81.52 45.3,0 82.36,-37.13 85.89,-81.51 0.18,2.28 0.28,4.59 0.28,6.92 0,42.42 -30.63,77.69 -70.98,84.9zm50.24 -223.81c-0.25,-20.92 -0.03,-41.98 -0.03,-62.93 0.02,-14.11 -3.24,-25.43 -16.11,-31.72 -3.33,-1.63 -8.53,-3.53 -12.69,-2.76l0.02 39.87c1.24,-1.95 2.66,-1.64 4.54,-1.09 2.58,8.28 -0.87,83.37 1.05,89.99 3.07,10.58 17.15,11.32 21.99,1.87 2.15,-4.21 1.13,-12.2 1.24,-17.43l-0.04 -1.76 0.06 -11.57 -0.02 -2.48zm-98.54 15.06l0 12.52 -1.7 0.65c-1.3,0.39 -0.26,-0.24 -1.84,0.48 -0.59,14.19 -0.07,29.52 -0.07,43.83l0 88.79c0,10.15 -2.76,27.83 13.46,31.12 7.53,1.54 12.48,-1.53 16.08,-5.21 4.93,-5.06 4.53,-9.8 4.52,-17.95l0 -121.8c0,-3.24 -0.92,-8.36 2.57,-8.35 3.4,0 2.59,4.62 2.56,7.78l0.03 121.81c0,7.73 -0.58,13.22 4.24,18.23 10.19,10.62 24.02,5.48 28.33,-4.15 2.37,-5.3 1.49,-14.63 1.49,-20.92 0,-14.8 0,-29.59 0,-44.4 0,-29.08 1,-59.94 -0.07,-88.8l-3.55 -1.14 -0.04 -13.1 0.07 -112.15 -7.96 0 0.01 80.74 -19.63 -0.96c-0.38,-8.12 -0.06,-16.85 -0.06,-24.89 0,-14.89 9.29,-41.68 15.96,-54.64l-42.87 -0.26c4.55,16.94 13.29,38.72 13.29,55.24 0,8.23 0.32,17.17 -0.06,25.31l-16.68 0.2 -0.17 -80.69 -7.9 -0.08 -0.03 112.76zm25.49 -179.99c-3.48,2.8 -3.86,-3.15 -4.28,-5.7 -0.51,-3.02 -1.07,-7.49 -1.87,-9.97 -9.11,4.71 -15.26,13.52 -16.39,27.17 -2.33,1.19 -5.11,0.84 -5.43,4.57 -0.33,3.76 1.87,5.04 5.34,5.04l60.34 0.01c3.31,-0.01 5.34,-1.08 5.35,-4.5 0.02,-4.41 -2.91,-3.86 -5.48,-5.13 -1.15,-13.83 -7.34,-22.37 -16.39,-27.18 -1.99,6.28 -1.51,19.79 -6.12,15.69 -2.54,-2.51 1.99,-14.87 1.51,-19.24 -1.7,-3.24 -8.35,-2.48 -11.9,-2.48 -13.8,0 0,17.11 -4.69,21.72zm34.49 27.26l-53.91 -0.18c-2.22,15.81 12.37,28.94 26.96,28.94 14.56,0 29.18,-13.22 26.95,-28.76z"/>
    // </svg>

    // `
    const src = 'data:image/svg+xml;charset=utf-8,'
      + encodeURIComponent(svg);
    return src;
  }
  trackHistory() {
    let date = new Date(this.traveVinData.timeStamp);
    let now = (date).toJSON();
    let from = (new Date(date.getTime() - 1000 * 60)).toJSON();
    this.commonService.presentLoader();
    if (!this.vin)
      this.vin = this.traveVinData.vin
    const url = serverUrl.web + '/device/trackhistory?vehicleNo=' + this.vin + '&fromDate=' + this.datePipe.transform(now, 'yyyy-MM-dd') +
      '&fromtime=' + this.datePipe.transform(from, 'HH:mm:ss') + '&totime=' + this.datePipe.transform(now, 'HH:mm:ss') + '&entryPoint=' + app.entryPoint;

    // let body = {
    //   "vin": this.vin,
    //   "fromDate": this.datePipe.transform(now, 'yyyy-MM-dd') + " " + this.datePipe.transform(from, 'hh:mm:ss a'),
    //   "toDate": this.datePipe.transform(now, 'yyyy-MM-dd') + " " + this.datePipe.transform(now, 'hh:mm:ss a'),
    // }
    this.ajaxService.ajaxGet(url)
      .subscribe(res => {
        if (this.commonService.isLoading)
          this.commonService.dismissLoader();
        let trackHistory = [];
        let trackHistoryArray = res.routeGeometry;
        trackHistoryArray.forEach(function (value) {
          if (value.latitude !== 0 && value.longitude !== 0) {
            let latLng = {
              lat: value.latitude,
              lng: value.longitude
            };
            trackHistory.push(latLng);
          }
        });
        this.trackHistoryJson = trackHistory;
        this.trackHistoryJson.forEach((element, index) => {
          let self = this;
          setTimeout(() => {
            if (self.currentState == "history") {
              self.plotMarkerinMap(element);
            }
          }, index * 2000);
        });
      });
  }
  ngOnChanges() {
    if (this.gridLiveChange) {
      if (this.websocketService.isAlive('livetrack')) {
        if (this.traveVinData) {
          this.traveVinData = this.gridLiveChange;
        }
        if (this.traveVinData.vin != this.vin) {
          this.appSettings = JSON.parse(localStorage.appSettings);
          const duration = this.appSettings.liveTrackingDisconnect ? this.appSettings.liveTrackingDisconnect : this.appSettings.liveTrackingDelay;
          const credentials = {
            dashboardVin: this.vin,
            defaultInterval: duration,
            make: storageVariable.upDatedJsonData.liveDatas[this.vin].make,
            model: storageVariable.upDatedJsonData.liveDatas[this.vin].model,
            delay: duration,
            ImeiNo: storageVariable.upDatedJsonData.liveDatas[this.vin].imeiNo,
            entryPoint: app.entryPoint,
            Check: false,
            emailId: localStorage.userName,
            branchID: localStorage.corpId,
            companyID: localStorage.corpId,
            mode: 'liveTrackDisConnect'
          };
          // if (!this.restrictedCommandImei.includes(this.traveVinData.imeiNo))
          this.websocketService.reSendRequest(credentials);
          if (!this.map) {
            this.map = this.mapService.loadMap(this.mapElement.nativeElement, { lat: this.traveVinData.latitude, lng: this.traveVinData.longitude }, false, false);
          }
          this.mapService.clearLayers(this.map, [1, 2]);
          this.paramVin = JSON.parse(localStorage.selectedVin).vin;
          this.appSettings = JSON.parse(localStorage.appSettings);
          this.ioData = JSON.parse(localStorage.staticIOData)[this.paramVin];
          this.traveVinData = storageVariable.upDatedJsonData.liveDatas[JSON.parse(localStorage.selectedVin).vin];
          this.position = {
            lat: this.traveVinData.latitude,
            lng: this.traveVinData.longitude
          };
          this.gridView.emit(this.traveVinData)
          this.createMap();
          this.trackHistory();
        }
      }
    }
    if (this.fromMultiTrack) {
      let vin = JSON.parse(localStorage.selectedVin).vin;

      vin = this.multiTrackObj['vin'];
      this.updateTracking(this.multiTrackObj);

    } else if (this.liveTrackChanging) {
      this.traveVinData = storageVariable.upDatedJsonData.liveDatas[JSON.parse(localStorage.selectedVin).vin];
      if (Object.keys(this.liveTrackChanging['liveDatas']).includes(this.traveVinData.vin)) {
        this.vin = this.traveVinData.vin
        const res = this.liveTrackChanging
        this.traveVinData = res["liveDatas"][this.traveVinData.vin];
        this.liveTrackModel = this.getLiveTrackIcon(this.commonService.color[this.traveVinData.status], this.commonService.vehicleModelmap[this.traveVinData.icon]);
        this.currentState = "live";

        this.traveVinData = res["liveDatas"][this.vin];

        this.successLiveVariableData(res);
        this.updateCellData();
      }
    }
  }
  updateTracking(data) {
    this.traveVinData = data;
    this.vin = this.traveVinData.vin
    this.liveTrackModel = this.getLiveTrackIcon(this.commonService.color[this.traveVinData.status], this.commonService.vehicleModelmap[this.traveVinData.icon]);
    this.currentState = "live";
    this.successLiveVariableData(data);
    this.updateCellData();

  }

  showLocation(data) {
    const url = serverUrl.web + "/login/company/latlngtoaddress/" + data.latitude + "/" + data.longitude + "/" + localStorage.corpId + "/" + localStorage.lang;
    this.ajaxService.ajaxGetObject(url)
      .subscribe(res => {
        if (JSON.stringify(res) == "{}") {
          data.location = data.latitude + ',' + data.longitude;
        } else {
          data.location = res;
        }

      });
  }

  ngOnInit() {
    this.appName = app.appName;
    this.pageSelector = localStorage.pageSelector
    if (this.fromMultiTrack) {
      this.setup(this.fromMultiTrack, this.multiTrackObj);
    } else {
      this.paramVin = JSON.parse(localStorage.selectedVin).vin;
      this.appSettings = JSON.parse(localStorage.appSettings);
      this.ioData = JSON.parse(localStorage.staticIOData)[this.paramVin];
      this.traveVinData = storageVariable.upDatedJsonData.liveDatas[JSON.parse(localStorage.selectedVin).vin];
      this.traveVinData['type'] = "liveTracking";
      this.vin = this.traveVinData.vin
      this.gridView.emit(this.traveVinData) // not used yet but don't delete
      this.createMap();
      // this.trackHistory();
      this.commonService.updateLanguageDir
        .subscribe(res => {
          this.directory = res == "" ? this.directory : res
        })
    }

  }
  setup(fromMultitrack = false, multiTrackObj) {
    let vin = JSON.parse(localStorage.selectedVin).vin;
    if (fromMultitrack) {
      vin = multiTrackObj.vin;
    }
    this.paramVin = vin;
    this.appSettings = JSON.parse(localStorage.appSettings);
    this.ioData = JSON.parse(localStorage.staticIOData)[this.paramVin];
    this.traveVinData = storageVariable.upDatedJsonData.liveDatas[vin];
    this.traveVinData['type'] = "liveTracking";
    this.vin = this.traveVinData.vin
    this.gridView.emit(this.traveVinData) // not used yet but don't delete
    this.createMap();
    //this.trackHistory();
    this.commonService.updateLanguageDir
      .subscribe(res => {
        this.directory = res == "" ? this.directory : res
      })
  }
}
